import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeftOutlined } from '@ant-design/icons';

import './formsHome.less';

export default function FormsSubpageLayout({
  history,
  title,
  subtitle,
  headerActions,
  children,
}) {
  return (
    <div className="forms-subpage">
      <button
        type="button"
        className="forms-subpage-back"
        onClick={() => history.push('/forms')}
      >
        <ArrowLeftOutlined />
        Back to Forms
      </button>

      <div className="forms-subpage-header">
        <div>
          <h1 className="forms-subpage-title">{title}</h1>
          {subtitle && (
            <p className="forms-subpage-subtitle">{subtitle}</p>
          )}
        </div>
        {headerActions && (
          <div className="forms-subpage-header-actions">
            {headerActions}
          </div>
        )}
      </div>

      <div className="forms-subpage-content">
        {children}
      </div>
    </div>
  );
}

FormsSubpageLayout.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  headerActions: PropTypes.node,
  children: PropTypes.node,
};

FormsSubpageLayout.defaultProps = {
  subtitle: null,
  headerActions: null,
  children: null,
};
